import * as Sentry from '@sentry/angular';

// Plain object wrapper so tests can spy on captureException.
// @sentry/angular v8 uses ESM-only exports that are non-configurable,
// making spyOn / Object.defineProperty impossible to use in Jasmine tests.
export const sentryHelper = {
  captureException: (error: any, context?: any) =>
    Sentry.captureException(error, context)
};
